import { OktonInput, OktonSelect, OktonTextarea } from '@okton/platform-ui';
import { Divider, VStack, useColorModeValue } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';

type AutomacaoData = {
  nome?: string;
  descricao?: string;
  gatilho?: string;
  configGatilho?: unknown;
};

type AutomacaoFormProps = {
  data?: AutomacaoData | null;
};

export default function AutomacaoForm({ data }: AutomacaoFormProps) {
  const [nome, setNome] = useState('');
  const [descricao, setDescricao] = useState('');
  const [gatilho, setGatilho] = useState('');
  const [configGatilho, setConfigGatilho] = useState('{}');

  const dividerColor = useColorModeValue('gray.200', 'gray.600');

  const gatilhos = [
    { value: 'produto_sincronizado', label: 'Produto sincronizado' },
    { value: 'novo_pedido_criado', label: 'Novo pedido criado' },
    { value: 'estoque_baixo', label: 'Estoque baixo' },
    { value: 'estoque_esgotado', label: 'Estoque esgotado' },
    { value: 'preco_alterado', label: 'Preço alterado' },
    { value: 'canal_conectado', label: 'Canal conectado' },
    { value: 'canal_desconectado', label: 'Canal desconectado' },
    { value: 'agendado', label: 'Agendado (horário específico)' },
  ];

  useEffect(() => {
    if (data) {
      setNome(data.nome || '');
      setDescricao(data.descricao || '');
      setGatilho(data.gatilho || '');
      setConfigGatilho(
        typeof data.configGatilho === 'object'
          ? JSON.stringify(data.configGatilho, null, 2)
          : data.configGatilho || '{}',
      );
    }
  }, [data]);

  return (
    <VStack spacing="4" align="stretch">
      <OktonInput
        name="nome"
        label="Nome"
        required
        value={nome}
        onChange={e => setNome(e.target.value)}
        placeholder="Ex: Notificar estoque baixo"
      />

      <OktonTextarea
        name="descricao"
        label="Descrição"
        value={descricao}
        onChange={e => setDescricao(e.target.value)}
        placeholder="Descreva o que esta automação faz..."
        size="sm"
      />

      <OktonSelect
        name="gatilho"
        label="Gatilho"
        required
        value={gatilho}
        onChange={e => setGatilho(e.target.value)}
        options={gatilhos}
      />

      <OktonTextarea
        name="configGatilho"
        label="Configuração do Gatilho (JSON)"
        value={configGatilho}
        onChange={e => setConfigGatilho(e.target.value)}
        placeholder='Ex: { "limite": 10 }'
        fontFamily="mono"
        fontSize="xs"
      />

      <Divider borderColor={dividerColor} pt={2} />
    </VStack>
  );
}
